export default "__VITE_ASSET__aCrGNdZp__"